'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const navItems = [
  // {
  //   label: 'Dashboard',
  //   href: '/dashboard',
  //   icon: (
  //     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  //     </svg>
  //   ),
  // },
  {
    label: 'Tour Types',
    href: '/tour-types',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
      </svg>
    ),
  },
  {
    label: 'Packages',
    href: '/packages',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
  },
  {
    label: 'Package Bookings',
    href: '/package-bookings',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V9a2 2 0 00-2-2h-2M8 7H7a1 1 0 000 2h10a1 1 0 000-2h-1" />
      </svg>
    ),
  },
  {
    label: 'Contact-us Enquiries',
    href: '/enquiries',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
      </svg>
    ),
  },
  {
    label: 'Package Itinerary',
    href: '/package-itinerary',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    label: 'Tour Schedule',
    href: '/tour-schedule',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Multi Day Itinerary',
    href: '/multi-day-itinerary',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V9a2 2 0 00-2-2h-2M8 7H7a1 1 0 000 2h10a1 1 0 000-2h-1" />
      </svg>
    ),
  },
  {
    label: 'Package FAQ',
    href: '/package-faqs',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    label: 'General FAQs',
    href: '/manage-faqs',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    label: 'Package Content',
    href: '/package-content',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
  },
  {
    label: 'Package Pricing',
    href: '/package-pricing',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    label: 'Package Gallery',
    href: '/package-gallery',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Private Transfer Bookings',
    href: '/transfer-bookings',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
      </svg>
    ),
  },
  {
    label: 'Private Transfers',
    href: '/private-transfers',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
      </svg>
    ),
  },
  // {
  //   label: 'Users',
  //   href: '/users',
  //   icon: (
  //     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
  //     </svg>
  //   ),
  // },
  // {
  //   label: 'Analytics',
  //   href: '/analytics',
  //   icon: (
  //     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
  //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  //     </svg>
  //   ),
  // },
  {
    label: 'Coupons',
    href: '/coupons',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
      </svg>
    ),
  },
  {
    label: 'SEO Management',
    href: '/seo-management',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    ),
  },
  {
    label: 'Settings',
    href: '/settings',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    label: 'Manage Instagram',
    href: '/manage-instagram',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: 'Manage Blog',
    href: '/manage-blog',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
      </svg>
    ),
  },
  {
    label: 'Manage YouTube',
    href: '/manage-youtube',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12l-5-3v6l5-3zm6.34-3.64a2.25 2.25 0 00-1.58-1.59C18.37 6.4 12 6.4 12 6.4s-6.37 0-7.76.37A2.25 2.25 0 002.66 8.36 23.51 23.51 0 002.3 12c0 1.25.13 2.49.36 3.64a2.25 2.25 0 001.58 1.59c1.39.37 7.76.37 7.76.37s6.37 0 7.76-.37a2.25 2.25 0 001.58-1.59c.23-1.15.36-2.39.36-3.64s-.13-2.49-.36-3.64z" />
      </svg>
    )
  },
  {
    label: 'Cancellation Policy',
    href: '/cancellation-policy',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    label: 'Terms & Conditions',
    href: '/terms-conditions',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    ),
  },
  {
    label: 'Privacy Policy',
    href: '/privacy-policy',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    label: 'Website Gallery',
    href: '/website-gallery',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Hero Videos',
    href: '/website-gallery/hero-videos',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Email Templates',
    href: '/email-templates',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Homepage Videos',
    href: '/homepage-videos',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    label: 'Popular Tours',
    href: '/homepage-popular-tours',
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.907c.961 0 1.36 1.246.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.773-.564-.373-1.81.588-1.81h4.906a1 1 0 00.95-.69l1.519-4.674z" />
      </svg>
    ),
  }
];

const Sidebar = ({ isOpen, onClose }) => {
  const pathname = usePathname();
  const firstLinkRef = React.useRef(null);
  
  // Packages Dropdown State & Config
  const [isPackagesOpen, setIsPackagesOpen] = React.useState(false);
  const packageSubHrefs = [
    '/packages',
    '/package-bookings',
    '/multi-day-itinerary',
    '/package-itinerary',
    '/tour-schedule',
    '/package-faqs',
    '/package-content',
    '/package-pricing',
    '/package-gallery'
  ];

  React.useEffect(() => {
    if (packageSubHrefs.includes(pathname)) {
      setIsPackagesOpen(true);
    }
  }, [pathname]);

  const handleDropdownClick = (e) => {
    e.preventDefault();
    if (!isOpen) {
      const toggleBtn = document.querySelector('[aria-label="Expand Sidebar"]');
      if (toggleBtn) {
        toggleBtn.click();
      }
      setIsPackagesOpen(true);
    } else {
      setIsPackagesOpen(!isPackagesOpen);
    }
  };

  // Transfers Dropdown State & Config
  const [isTransfersOpen, setIsTransfersOpen] = React.useState(false);
  const transferSubHrefs = [
    '/transfer-bookings',
    '/private-transfers'
  ];

  React.useEffect(() => {
    if (transferSubHrefs.includes(pathname)) {
      setIsTransfersOpen(true);
    }
  }, [pathname]);

  const handleTransfersDropdownClick = (e) => {
    e.preventDefault();
    if (!isOpen) {
      const toggleBtn = document.querySelector('[aria-label="Expand Sidebar"]');
      if (toggleBtn) {
        toggleBtn.click();
      }
      setIsTransfersOpen(true);
    } else {
      setIsTransfersOpen(!isTransfersOpen);
    }
  };

  React.useEffect(() => {
    if (isOpen && window.innerWidth < 1024) {
      firstLinkRef.current?.focus();
    }
  }, [isOpen]);

  const corePaths = ['/tour-types', '/enquiries'];
  const operationsPaths = ['/manage-faqs', '/website-gallery', '/website-gallery/hero-videos', '/homepage-videos', '/manage-instagram', '/manage-blog', '/manage-youtube', '/coupons', '/homepage-popular-tours'];
  const adminPaths = ['/users', '/email-templates', '/cancellation-policy', '/terms-conditions', '/privacy-policy', '/seo-management', '/settings'];

  const sections = [
    {
      title: 'Core',
      items: [
        ...navItems.filter(item => item.href === '/tour-types').map(item => ({ type: 'link', ...item })),
        {
          type: 'dropdown',
          label: 'Packages',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          ),
          subHrefs: packageSubHrefs,
          isOpenState: isPackagesOpen,
          onClick: handleDropdownClick,
          subItems: [
            { label: 'All Packages', href: '/packages' },
            { label: 'Package Bookings', href: '/package-bookings' },
            { label: 'Package Itinerary', isHeader: true },
            { label: 'Multiday Itinerary', href: '/multi-day-itinerary', isIndented: true },
            { label: 'Shared/Private Itinerary', href: '/package-itinerary', isIndented: true },
            { label: 'Shared Tour Schedule', href: '/tour-schedule' },
            { label: 'Package FAQ', href: '/package-faqs' },
            { label: 'Package Content', href: '/package-content' },
            { label: 'Package Pricing', href: '/package-pricing' },
            { label: 'Package Gallery', href: '/package-gallery' },
          ]
        },
        {
          type: 'dropdown',
          label: 'Private Transfers',
          icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
            </svg>
          ),
          subHrefs: transferSubHrefs,
          isOpenState: isTransfersOpen,
          onClick: handleTransfersDropdownClick,
          subItems: [
            { label: 'Private Transfer Bookings', href: '/transfer-bookings' },
            { label: 'Private Transfers', href: '/private-transfers' },
          ]
        },
        ...navItems.filter(item => corePaths.includes(item.href) && item.href !== '/tour-types').map(item => ({ type: 'link', ...item }))
      ]
    },
    {
      title: 'Operations',
      items: navItems.filter(item => operationsPaths.includes(item.href)).map(item => ({ type: 'link', ...item }))
    },
    {
      title: 'Admin',
      items: navItems.filter(item => adminPaths.includes(item.href)).map(item => ({ type: 'link', ...item }))
    }
  ];

  return (
    <>
      {/* Mobile Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Sidebar Content */}
      <aside
        className={`fixed inset-y-0 left-0 z-50 bg-[#222222] border-r border-white/10 transition-all duration-300 ease-in-out ${isOpen
            ? 'w-72 translate-x-0'
            : 'w-20 lg:translate-x-0 -translate-x-full'
          }`}
        aria-label="Sidebar Navigation"
      >
        <div className="flex flex-col h-full overflow-hidden">
          {/* Sidebar Header */}
          <div className={`h-24 flex items-center justify-center border-b border-white/10 transition-all duration-300 relative px-4`}>
            <div className={`flex items-center justify-center transition-all duration-300 ${isOpen ? 'opacity-100 w-full' : 'opacity-0 w-0 overflow-hidden'}`}>
              <img
                src="/logo.png"
                alt="Wild Northern Logo"
                className="h-14 w-auto object-contain"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>

            {!isOpen && (
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center border border-white/20 shadow-lg overflow-hidden transition-all duration-300 hover:bg-white/20">
                <img
                  src="/logo.png"
                  alt="Logo"
                  className="w-8 h-8 object-contain brightness-0 invert"
                  onError={(e) => {
                    e.target.src = "https://ui-avatars.com/api/?name=W&background=white&color=4f5a50&bold=true";
                  }}
                />
              </div>
            )}

            <button
              onClick={onClose}
              className={`absolute right-4 p-2 rounded-lg hover:bg-white/10 text-white/70 lg:hidden`}
              aria-label="Close Sidebar"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Nav Menu */}
          <nav className="flex-1 px-3 py-8 space-y-6 overflow-y-auto custom-scrollbar overflow-x-hidden">
            {sections.map((section, sIdx) => (
              <div key={section.title} className="flex flex-col space-y-2">
                <span className={`px-4 text-[13px] text-white/70 transition-all duration-300 ${isOpen ? 'opacity-100 h-auto mb-1' : 'opacity-0 h-0 m-0 overflow-hidden'}`}>
                  {section.title}
                </span>
                {section.items.map((item, i) => {
                  if (item.type === 'dropdown') {
                    const isAnySubActive = item.subHrefs.includes(pathname);
                    const isDropdownOpen = item.isOpenState;
                    return (
                      <div key={item.label} className="flex flex-col space-y-1">
                        <button
                          onClick={item.onClick}
                          className={`w-full flex items-center rounded-xl transition-all duration-200 group relative ${isOpen ? 'px-4 py-2.5 justify-between' : 'p-3 justify-center'
                            } ${isAnySubActive
                              ? 'bg-[#4f5a50]/20 text-white border border-white/10'
                              : 'text-white/60 hover:bg-white/5 hover:text-white'
                            }`}
                          title={!isOpen ? item.label : ''}
                        >
                          <div className={`flex items-center ${isOpen ? 'space-x-3' : ''}`}>
                            <span className={`${isAnySubActive ? 'text-white' : 'text-white/40 group-hover:text-white'} transition-colors flex-shrink-0`}>
                              {item.icon}
                            </span>
                            <span className={`text-[13px] uppercase tracking-wider text-left whitespace-nowrap transition-all duration-300 overflow-hidden ${isOpen ? 'opacity-100 w-auto' : 'opacity-0 w-0'
                              }`}>
                              {item.label}
                            </span>
                          </div>
                          {isOpen && (
                            <svg className={`w-4 h-4 text-white/40 group-hover:text-white transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                            </svg>
                          )}

                          {/* Interactive Tooltip for collapsed state */}
                          {!isOpen && (
                            <div className="fixed left-20 ml-2 p-3 bg-gray-900 text-white rounded shadow-xl opacity-0 group-hover:opacity-100 transition-opacity z-[100] border border-white/10 flex flex-col space-y-1.5 min-w-[200px] pointer-events-none group-hover:pointer-events-auto">
                              <div className="text-[10px] font-black uppercase tracking-widest text-white/40 border-b border-white/10 pb-1 mb-1">
                                {item.label}
                              </div>
                              {item.subItems.map((sub, subIdx) => {
                                if (sub.isHeader) {
                                  return (
                                    <div key={subIdx} className="text-[8px] font-bold text-white/30 uppercase tracking-wider mt-1.5 first:mt-0">
                                      {sub.label}
                                    </div>
                                  );
                                }
                                const isSubActive = pathname === sub.href;
                                return (
                                  <Link
                                    key={sub.href}
                                    href={sub.href}
                                    className={`text-[11px] font-bold uppercase tracking-wider block hover:text-white ${isSubActive ? 'text-[#0ab39c]' : 'text-white/60'}`}
                                  >
                                    {sub.label}
                                  </Link>
                                );
                              })}
                            </div>
                          )}
                        </button>

                        {/* Dropdown menu items */}
                        {isOpen && isDropdownOpen && (
                          <div className="border-l border-white/10 ml-6 pl-2 space-y-1 flex flex-col animate-in slide-in-from-top-1 duration-200">
                            {item.subItems.map((sub, subIdx) => {
                              if (sub.isHeader) {
                                return (
                                  <div key={subIdx} className="px-4 py-1 text-[10px] font-bold text-white/30 uppercase tracking-widest mt-2 select-none">
                                    {sub.label}
                                  </div>
                                );
                              }
                              const isSubActive = pathname === sub.href;
                              return (
                                <Link
                                  key={sub.href}
                                  href={sub.href}
                                  className={`flex items-center px-4 py-2 text-[12px] uppercase tracking-wider transition-colors duration-200 rounded-lg ${sub.isIndented ? 'pl-6' : ''} ${
                                    isSubActive
                                      ? 'text-white font-bold bg-white/10'
                                      : 'text-white/50 hover:text-white hover:bg-white/5'
                                  }`}
                                  onClick={() => {
                                    if (window.innerWidth < 1024) onClose();
                                  }}
                                >
                                  <span className={`w-1.5 h-1.5 rounded-full mr-2.5 flex-shrink-0 transition-colors ${isSubActive ? 'bg-[#0ab39c]' : 'bg-white/20'}`} />
                                  {sub.label}
                                </Link>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }

                  const isActive = pathname === item.href;
                  return (
                    <Link
                      key={item.href}
                      ref={sIdx === 0 && i === 0 ? firstLinkRef : null}
                      href={item.href}
                      className={`flex items-center rounded-xl transition-all duration-200 group relative ${isOpen ? 'px-4 py-2.5 space-x-3' : 'p-3 justify-center'
                        } ${isActive
                          ? 'bg-[#4f5a50] text-white shadow-lg shadow-black/10'
                          : 'text-white/60 hover:bg-white/5 hover:text-white'
                        }`}
                      onClick={() => {
                        if (window.innerWidth < 1024) onClose();
                      }}
                      title={!isOpen ? item.label : ''}
                    >
                      <span className={`${isActive ? 'text-white' : 'text-white/40 group-hover:text-white'} transition-colors flex-shrink-0`}>
                        {item.icon}
                      </span>
                      <span className={`text-[13px] uppercase tracking-wider whitespace-nowrap transition-all duration-300 overflow-hidden ${isOpen ? 'opacity-100 w-auto' : 'opacity-0 w-0'
                        }`}>
                        {item.label}
                      </span>

                      {/* Tooltip for collapsed state */}
                      {!isOpen && (
                        <div className="fixed left-20 ml-2 px-3 py-2 bg-gray-900 text-white text-[10px] font-black uppercase tracking-widest rounded shadow-xl opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-[100] border border-white/10">
                          {item.label}
                        </div>
                      )}
                    </Link>
                  );
                })}
              </div>
            ))}
          </nav>

          {/* Footer/Bottom section */}
          <div className={`p-6 border-t border-white/10 transition-all duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 h-0 p-0 overflow-hidden'}`}>
            <div className="flex items-center space-x-3 px-3 py-2 text-white/50">
              <div className="w-2 h-2 rounded-full bg-[#0ab39c] animate-pulse" />
              <span className="text-[11px] font-black uppercase tracking-widest">Online</span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
